import { render, staticRenderFns } from "./RotationConfigPanel.vue?vue&type=template&id=63a3cdc8&scoped=true"
import script from "./RotationConfigPanel.vue?vue&type=script&lang=js"
export * from "./RotationConfigPanel.vue?vue&type=script&lang=js"
import style0 from "./RotationConfigPanel.vue?vue&type=style&index=0&id=63a3cdc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a3cdc8",
  null
  
)

export default component.exports